module.exports = __webpack_public_path__ + "img/brand-strava.0da07715.svg";